module.exports = __webpack_public_path__ + "static/media/35.1693349d.svg";